<template>
	<div>
		<SOFilterTitle :title="'Urut Berdasarkan'" :is-collapsing="false" :id="id"/>
		<div class="p-l-24 p-r-24 p-d-24" :id="id">
			<SOInputRadio
				:radios="sorting"
				:v2="true"
				:selected-radio="JSON.stringify(filter)"
				@selected="selected"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputRadio from "@/so-components/global/input/SOInputRadio";

export default {
	name: "SOFilterSortingV2",
	components: {
		SOFilterTitle,
		SOInputRadio,
	},
	props: {
		id: String,
		sorting: Array,
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filter: "getFilter"
		})
	},
	methods: {
		selected(payload) {
			this.$store.commit("filterGlobalModule/setFilter", JSON.parse(payload.value))
		}
	}
}
</script>